// tokens.ts — 自動生成（build-tokens.mjs）。手で編集しない。元データ: tokens.json
// 例) tokens.utility.neutral.text / tokens.value.spacing.card.medium / tokens.value.sizing.font.console.h1
export const tokens = {
    "common": {
        "value": {
            "v0": 0,
            "v1": 1,
            "v2": 2,
            "v3": 3,
            "v4": 4,
            "v6": 6,
            "v8": 8,
            "v11": 11,
            "v12": 12,
            "v13": 13,
            "v14": 14,
            "v16": 16,
            "v18": 18,
            "v20": 20,
            "v22": 22,
            "v24": 24,
            "v26": 26,
            "v32": 32,
            "v44": 44,
            "v48": 48,
            "v64": 64,
            "v96": 96,
            "v170": 170,
            "v270": 270,
            "v280": 280,
            "v400": 400,
            "v420": 420,
            "v500": 500,
            "v1200": 1200,
            "v1280": 1280,
            "v1512": 1512,
            "v9999": 9999
        },
        "string": {
            "fontName": {
                "japan": "Noto Sans JP",
                "latin": "Roboto"
            },
            "fontWeight": {
                "bold": 700,
                "medium": 500,
                "regular": 400
            }
        }
    },
    "value": {
        "spacing": {
            "item": {
                "medium": 4
            },
            "set": {
                "small": 8,
                "medium": 12
            },
            "card": {
                "medium": 16
            },
            "column": {
                "medium": 24
            },
            "content": {
                "medium": 32
            },
            "section": {
                "medium": 48
            },
            "page": {
                "medium": 96
            },
            "text": {
                "letterSpacing": {
                    "small": 0.5
                },
                "paragraphSpacing": {
                    "xsmall": 4,
                    "medium": 8
                }
            }
        },
        "sizing": {
            "font": {
                "decoration": {
                    "h1": 48,
                    "h2": 32,
                    "h3": 24
                },
                "console": {
                    "h1": 26,
                    "h3": 22,
                    "row": 13,
                    "meta": 11
                },
                "normal": {
                    "h4": 20,
                    "h5": 18,
                    "h6": 16,
                    "p1": 16,
                    "p2": 14,
                    "p3": 12
                }
            },
            "lineHeight": {
                "heading": 1.2,
                "body": 1.4
            },
            "border": {
                "default": 1,
                "secondary": 2,
                "tertiary": 3
            },
            "radius": {
                "badge": 3,
                "input": 6,
                "tab": 6,
                "button": 6,
                "image": 8,
                "card": 8,
                "column": 12,
                "tag": 16,
                "full": 9999
            },
            "device": {
                "width": 1512,
                "minimum": 1280
            },
            "width": {
                "content": 1200,
                "form": 500,
                "auth": 400
            },
            "component": {
                "header": 64,
                "sidebar": 280,
                "control": 44,
                "chip": 22,
                "logo": 22
            },
            "icon": {
                "small": 18,
                "medium": 20,
                "default": 24,
                "large": 48
            },
            "grid": {
                "kpiColumns": 4
            }
        },
        "appearance": {
            "shadow": {
                "overlay": "0 12px 30px rgba(16,24,40,0.22)",
                "bar": "0 -2px 10px rgba(0,0,0,0.08)"
            }
        },
        "animation": {
            "duration": {
                "fast": "0.2s",
                "standard": "0.25s"
            },
            "easing": {
                "standard": "ease"
            }
        }
    },
    "column": {
        "minimum": {
            "content": 420,
            "column": 270,
            "card": 170
        }
    },
    "brand": {
        "navy": {
            "light": "#E6EAED",
            "tertiary": "#62798C",
            "tertiarySoft": "#677F92",
            "secondary": "#1A3F5C",
            "primary": "#012A4A",
            "deep": "#012242"
        },
        "green": {
            "light": "#E8F5E9",
            "primary": "#2E7D32"
        },
        "red": {
            "light": "#FDECEA",
            "primary": "#B3261E",
            "deep": "#8F1E18"
        },
        "amber": {
            "light": "#FFF4E5",
            "secondary": "#C77800",
            "primary": "#A16100"
        },
        "blue": {
            "primary": "#1565C0"
        }
    },
    "opacity": {
        "black": {
            "v4": "rgba(0,0,0,0.04)",
            "v23": "rgba(0,0,0,0.23)",
            "v35": "rgba(0,0,0,0.35)"
        },
        "navy": {
            "v8": "rgba(1,42,74,0.08)",
            "v12": "rgba(1,42,74,0.12)"
        }
    },
    "utility": {
        "neutral": {
            "background": "#FFFFFF",
            "secondary": "#E6EAED",
            "panel": "#F8F9FA",
            "portal": "#F0F2F5",
            "tableHead": "#FAFAFA",
            "annotation": "#626A70",
            "text": "#1B1B1B",
            "disabled": "#8D98A0",
            "footer": "#828282"
        },
        "line": {
            "default": "#E0E0E0",
            "subtle": "#EBEBEB",
            "faint": "#F2F2F2",
            "control": "rgba(0,0,0,0.23)",
            "focus": "#012A4A"
        },
        "function": {
            "select": "#012A4A",
            "link": "#012A4A",
            "linkHover": "#012242",
            "success": "#2E7D32",
            "required": "#B3261E",
            "caution": "#A16100",
            "warning": "#C77800",
            "info": "#1565C0",
            "onColor": "#FFFFFF"
        },
        "base": {
            "green": "#E8F5E9",
            "red": "#FDECEA",
            "orange": "#FFF4E5",
            "gray": "#F0F0F0",
            "selected": "rgba(1,42,74,0.08)",
            "selectedHover": "rgba(1,42,74,0.12)",
            "hover": "rgba(0,0,0,0.04)",
            "scrim": "rgba(0,0,0,0.35)"
        },
        "chart": {
            "series1": "#012A4A",
            "series2": "#62798C",
            "series3": "#1565C0",
            "series4": "#2E7D32",
            "series5": "#C77800",
            "series6": "#B3261E",
            "grid": "#EBEBEB",
            "label": "#626A70"
        }
    },
    "accent": {
        "simulator": {
            "blue": "#2F80ED",
            "blueStrong": "#1F6FE0",
            "green": "#27AE60",
            "greenText": "#1D8248",
            "text": "#1B1B1B",
            "textLight": "#6B7280",
            "textSubtle": "#6E7377",
            "muted": "#9AA0A6",
            "line": "#E6E8EB",
            "row": "#F7F8FA",
            "head": "#EEF2F7",
            "foot": "#F1F5FB"
        },
        "rank": {
            "s": "#765DF4",
            "a": "#1F6FE0",
            "b": "#1D8248",
            "c": "#F5A623",
            "d": "#9AA0A6"
        }
    }
};
export default tokens;
